//------------------------------------------------------ externos
import { useEffect, useState } from "react";
//------------------------------------------------------ elementos
import FormContent from "../funcionales/FormContent";
import MarcoModal from "../funcionales/MarcoModal";
import FormHeader from "../funcionales/FormHeader";
import TextButton from "../buttons/TextButton";
import Loading from "../../routes/Loading";
//------------------------------------------------------ funciones
import { cargarSelects } from "../../functions/dataFunctions";
import { submitTractor } from "./data/Submits";
import { elementos } from "./data/FormContent";
//import { refreshCache } from "../../services/cache";
//------------------------------------------------------ estilos
import { useCerrarConEsc } from "../../hooks/useCerrarConEsc";
import "./css/Forms.css";

const FormTractor = ({ elemento = null, onGuardar, onClose }) => {
  useCerrarConEsc(onClose);

  const modoEdicion = !!elemento;
  const titulo = modoEdicion ? "Editar" : "Agregar";
  const subtitulo = "Tractor";
  const campos = elementos["tractores"];

  const [loading, setLoading] = useState(true);
  const [listas, setListas] = useState({}); //para los selects, recibe un array tipo {tractores: ..., furgones: ...}
  const [formData, setFormData] = useState({
    // información específica
    id: elemento?.id || "",
    chasis: elemento?.chasis || "",
    dominio: elemento?.dominio || "",
    marca: elemento?.marca || "",
    modelo: elemento?.modelo || "",
    motor: elemento?.motor || "",
    // información laboral
    interno: elemento?.interno || "",
    empresa: elemento?.empresa || "",
    persona: elemento?.persona || "",
    satelital: elemento?.satelital || "",
    /* `estado_manual` y no `estado`: aquél es el crudo que heredó Firestore en
     * cinco formas, y éste es lo que declara una persona. Antes se cargaba
     * `estado` acá y no había ningún input que lo cambiara —el campo no estaba
     * en `elementos.tractores`— así que viajaba a la base tal cual venía. */
    estado_manual: elemento?.estado_manual || "",
    // detalles y comentarios
    detalle: elemento?.detalle || "",
    comentarioSatelital: elemento?.comentarioSatelital || "",
    detalleSatelital: elemento?.detalleSatelital || "",
  });

  useEffect(() => {
    const cargarDatos = async () => {
      const data = await cargarSelects(); // trae TODOS los listados, ver si se puede mejorar desp
      setListas(data);
    };

    cargarDatos();
    setLoading(false);
  }, []);

  const handleSubmit = async (e) => {
    e.preventDefault();

    await submitTractor(
      formData,
      campos,
      setLoading,
      onGuardar,
      onClose,
      modoEdicion,
      elemento?.id,
    );
  };

  return (
    <MarcoModal onClose={onClose}>
      {loading ? (
        <Loading />
      ) : (
        <div className="form-content">
          <FormHeader title={titulo} subTitle={subtitulo} onClose={onClose} />

          <FormContent
            elemento={elemento}
            campos={campos}
            opciones={listas}
            data={formData}
            setData={setFormData}
          />

          <div className="form-buttons">
            <TextButton
              text={"Guardar"}
              type={"button"}
              onClick={handleSubmit}
            />
          </div>
        </div>
      )}
    </MarcoModal>
  );
};

export default FormTractor;
